import type { BrowserOptions } from "@sentry/react";
import type { PostHogConfig } from "posthog-js";
import { PosthogServiceConfig } from "../services/posthog";

export const POSTHOG_CONFIG:PosthogServiceConfig = {
  apiKey: "phc_6uWwvGgsIhQxnLOAMxc397EL9B69YH5TvorI0yHEBs8", // public facing key, not a leaking secret
  apiHost: "https://us.i.posthog.com",
  options: {
    // before_send: (event) => {
    //   console.log("PostHog event to be sent:", event);
    //   return event;
    // },
  } satisfies Partial<PostHogConfig>,
};

export const SENTRY_CONFIG = {
  options:{
    dsn: "https://35b81b7b57452b6368ee86fcfaf6bc33@o516902.ingest.us.sentry.io/4510198128115712", // public facing key, not a leaking secret
    environment: process.env.NODE_ENV || "development",
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  } satisfies Partial<BrowserOptions>
};
